module.exports = __webpack_public_path__ + "static/media/Menarini_Cookies_Policy_Esp-V2.54c4792d.pdf";